module.exports = __webpack_public_path__ + "static/media/icon-hq.c67350dc.png";